export default __webpack_public_path__ + "static/cross-lines-549455a5bd56c7ef5f7ab23006427875.png";